import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../i18n";
import { SITE_URL } from "../lib/finishes";

const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

// Per-route SEO: title, description, canonical, hreflang (en/fr), OG/Twitter,
// html lang and optional JSON-LD. Robots is managed separately in App RouteMeta.
export default function Seo({ path = "/", title, description, image = OG_IMAGE, type = "website", jsonLd }) {
  const { lang } = useI18n();
  const canonical = `${SITE_URL}${path}`;
  const frUrl = `${canonical}${path.includes("?") ? "&" : "?"}lang=fr`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-CA" href={canonical} />
      <link rel="alternate" hrefLang="fr-CA" href={frUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="2TSticker" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === "fr" ? "fr_CA" : "en_CA"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
